import clsx from 'clsx'
import React from 'react'
import { makeStyles } from '@material-ui/core'
import { useVisualBlocksContext } from '../VisualBlocksContext'
import { getClassNameByDepth } from '../utils'

const useStyles = makeStyles(() => ({
  '@keyframes pulse': {
    '0%': {
      opacity: 0.5
    },
    '100%': {
      opacity: 1
    }
  },
  animatePulse: {
    animation: '$pulse 1.5s ease-in-out infinite alternate'
  }
}))

function LoadingState () {
  const classes = useStyles()
  const { classNames, styles } = useVisualBlocksContext()
  const blockClassName = getClassNameByDepth(classNames, 'block', 0)
  return (
    <div
      className={clsx('flex flex-row gap-2 w-full', classNames?.container)}
      style={{ minHeight: '500px', ...(styles?.container ?? {}) }}
    >
      <div className='w-full'>
        <div className='h-full w-full flex gap-5'>
          <div
            className={clsx('flex h-full w-full bg-neutral-300 animate-pulse rounded', blockClassName, classes.animatePulse)}
            style={{ width: '280px' }}
          />

          <div className={clsx('flex-1 flex flex-col gap-5', classNames.listItemContainer, classes.animatePulse)}>
            {Array.from({ length: 8 }).map((_, index) => (
              <div
                key={index}
                className={clsx('flex h-full w-full bg-neutral-300 animate-pulse rounded', classNames.listItems, classes.animatePulse)}
                style={{ height: '40px' }}
              />
            ))}
          </div>
          <div className={clsx('flex-1 flex flex-col gap-5', classNames.listItemContainer, classes.animatePulse)}>
            {Array.from({ length: 8 }).map((_, index) => (
              <div
                key={index}
                className={clsx('flex h-full w-full bg-neutral-300 animate-pulse rounded', classNames.listItems, classes.animatePulse)}
                style={{ height: '40px' }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default LoadingState
